import * as actionTypes from "./actionTypes";
import * as actions from "./index";
import { saveUploadInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";


export const setAddFormState = (formState) => {
    return {
        type: actionTypes.CUSTOM_SET_ADDFORM_STATE,
        payload: formState
    }
}

export const setNewData = (newData) => {
    return {
        type: actionTypes.CUSTOM_SET_NEWDATA,
        payload: newData
    }
}

export const sendEmailStart = (emailObj) => {
    return {
        type: actionTypes.CUSTOM_SEND_EMAIL_START,
        payload: emailObj
    }
}

export const sendEmailSuccess = (res) => {
    return {
        type: actionTypes.CUSTOM_SEND_EMAIL_SUCCESS,
        payload: res
    }
}

export const sendEmail = (emailObj) => {
    let isUploading = false;
    if (emailObj && ((emailObj.text && emailObj.text !== "") || (emailObj.htm && emailObj.html !== ""))) {
        return (dispatch, getState) => {
            dispatch(sendEmailStart(emailObj));
            if (getState().customData.customUploadInfo && getState().customData.customUploadInfo.isLoading) isUploading = true;
            if (isUploading) saveUploadInfo(dispatch, emailObj, "", 'SendEmail');

            window.flow.mail(emailObj).then(res => {
                if (isUploading) saveUploadInfo(dispatch, res, "", 'SendEmailStatus');
                dispatch(sendEmailSuccess(res));
                dispatch(actions.addMessage('popup.title.email.send.success', null, 'text', 'dialog'));
            });

        }
    }
    return;
}

export const saveLastCustomData4UserSuccess = (res) => {
    return {
        type: actionTypes.CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS,
        payload: res
    }
}

export const setCustomFullTextSearchData = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_FULLTEXT_SEARCH_DATA,
        payload: data
    }
}

export const setCustomLastByFieldsData = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_BYFIEDS_SEARCH_DATA,
        payload: data
    }
}

export const setCustomLastSearchType = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_LAST_SEARCH_TYPE,
        payload: data
    }
}

export function saveLastCustomData4User(userdata, option, lastCustomData) {
    let userid = userdata.id;
    let groupid = userdata.groupid;
    return dispatch => {
        window.flow.grantingEditUser(parseInt(groupid), parseInt(userid), [
            { 'name': option, 'value': { ...lastCustomData } }
        ], true).then((res) => {
            dispatch(saveLastCustomData4UserSuccess(res));
        }).catch(err => {
            console.log("LAMTEST grantingEditUser err", err);
        });
    }
}

export const saveCustomCurrentUser = (user) => {
    return {
        type: actionTypes.CUSTOM_SAVE_CURRENTUSER,
        payload: user
    }
}

export const setCustomCurrentHistory = (action) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENTHISTORY,
        payload: action
    }
}

export const setCustomCurrentClipData = (action) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENTCLIPDATA,
        payload: action
    }
}

export const setCustomCurrentSortOption = (option) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_SORTOPTION,
        payload: option
    }
}

export const getCustomLastSearch = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_LAST_SEARCH,
        payload: data
    }
}

export const setCustomCurrentDialog = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_DIALOG,
        payload: data
    }
}


export const reloadCustomProject = (data) => {
    return {
        type: actionTypes.CUSTOM_RELOAD_PROJECT,
        payload: data
    }
}

export const setCustomCurrentProject = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_PROJECT,
        payload: data
    }
}

export const setCustomEmptyProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_EMPTY_PROJECTS,
        payload: data
    }
}

export const setCustomDeletedProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_DELETED_PROJECTS,
        payload: data
    }
}

export const setCustomDeletedRooms = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_DELETED_ROOMS,
        payload: data
    }
}

export const setCustomUpdatedProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_UPDATED_PROJECTS,
        payload: data
    }
}

export const getCustomConfigClipInfoForApp = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_CONFIGCLIPINFO_FORAPP,
        payload: data
    }
}

export const setCustomCurrentMainFilter = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_MAIN_FILTER,
        payload: data
    }
}

export const setCustomCurrentSubFilter = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_SUB_FILTER,
        payload: data
    }
}


export const setCustomUploadInfo = (info) => {
    return {
        type: actionTypes.CUSTOM_SET_UPLOAD_INFO,
        payload: info
    }
}

export const setCustomSearchInfo = (info) => {
    return {
        type: actionTypes.CUSTOM_SET_SEARCH_INFO,
        payload: info
    }
}

export const setCustomCurrentUploadCount = () => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_UPLOAD_COUNT
    }
}

export const toggleCustomPopUpHidden = () => {
    return {
        type: actionTypes.CUSTOM_TOGGLE_POPUP_HIDDEN
    }
}

export const setCustomGoogleSignIn = (data) => {
    return {
        type: actionTypes.CUSTOM_GOOGLE_SIGN_IN,
        payload: data
    }
}


